import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "../hoc/Container";
import { CONSENT_PATH, OPERATOR, SELLER_NAME, SITE_URL } from "../legal/operator";
import { List, MailLink, Section } from "../legal/policyBlocks";
import { CAPTCHA_NOTICE_URL } from "../visoria/captcha";

function Purpose({ title, data, subjects, basis }) {
  return (
    <div className="policy-purpose">
      <p className="policy-purpose-title">{title}</p>
      <p>
        <span className="policy-label">Данные:</span> {data}
      </p>
      <p>
        <span className="policy-label">Субъекты:</span> {subjects}
      </p>
      <p>
        <span className="policy-label">Основание:</span> {basis}
      </p>
    </div>
  );
}

function PrivacyPage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    document
      .getElementById(location.hash.slice(1))
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location.hash]);

  return (
    <Container>
      <section className="main-content-block">
        <h1 className="main-title">Политика обработки персональных данных</h1>
        <div className="offer-text policy-text">
          <p className="policy-edition">Редакция от 8 октября 2026 г.</p>
          <Section id="general" title="1. Общие положения">
            <p>
              1.1. Настоящая Политика определяет порядок обработки и защиты
              персональных данных пользователей сайта{" "}
              <Link className="policy-link" to="/">
                {SITE_URL}
              </Link>{" "}
              и Telegram-ботов @trendy_steam_bot, @trendy_eng_shop_bot,
              @trendy_psn_bot (далее вместе — Сайт). Политика разработана в
              соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
              персональных данных».
            </p>
            <p>
              1.2. Оператор персональных данных — индивидуальный
              предприниматель Казаков Игорь Евгеньевич, ИНН {OPERATOR.inn},
              ОГРНИП {OPERATOR.ogrnip} (далее — Оператор). Регистрационный
              номер в реестре операторов, осуществляющих обработку
              персональных данных: {OPERATOR.registryNumber}. Электронная почта для обращений по вопросам
              персональных данных: <MailLink />.
            </p>
            <p>
              1.3. Продавцом цифровых товаров (кодов пополнения и подарочных
              карт), представленных на Сайте, является {SELLER_NAME}. Договор
              купли-продажи заключается между покупателем и {SELLER_NAME} на
              условиях{" "}
              <Link className="policy-link" to="/offer#offer">
                публичной оферты
              </Link>
              . Оператор обеспечивает работу Сайта, оформление заказов и
              передачу покупателю приобретённых кодов. Персональные данные
              покупателей Оператор продавцу не передаёт.
            </p>
            <p>
              1.4. Платёжные данные (реквизиты банковской карты, данные
              банковского счёта, адреса криптовалютных кошельков) покупатель
              вводит на странице платёжного сервиса. Оператор такие данные не
              получает и не обрабатывает.
            </p>
            <p>
              1.5. Используя Сайт, пользователь подтверждает, что ознакомлен с
              настоящей Политикой. Согласие на обработку персональных данных,
              когда оно требуется, оформляется отдельно: путём проставления
              отметки в соответствующей форме Сайта. Текст согласия размещён
              на странице{" "}
              <Link className="policy-link" to={CONSENT_PATH}>
                «Согласие на обработку персональных данных»
              </Link>
              .
            </p>
          </Section>

          <Section
            id="purposes"
            title="2. Цели обработки, состав данных и правовые основания"
          >
            <Purpose
              title="2.1. Подготовка, заключение и исполнение гражданско-правового договора: оформление и выполнение заказа, выдача кодов, поддержка покупателя, защита формы заказа от автоматических запросов."
              data="адрес электронной почты; логин аккаунта Steam (при пополнении Steam); номер, состав, сумма и статус заказа; имя и идентификатор пользователя (username) в Telegram (при обращении через бота); IP-адрес, сведения о браузере и устройстве; сведения о действиях на странице при проверке «Я не робот»."
              subjects="клиенты, выгодоприобретатели по договорам."
              basis="исполнение договора, выгодоприобретателем по которому является субъект персональных данных; согласие субъекта персональных данных."
            />
            <Purpose
              title="2.2. Ведение личного кабинета пользователя на Сайте: вход по коду, отправленному на адрес электронной почты, показ заказов и кодов, оформленных на этот адрес, подстановка адреса в форму заказа, хранение избранных игр. Применяется, если пользователь создаёт личный кабинет."
              data="адрес электронной почты; история заказов, оформленных на этот адрес; список избранных игр; дата и время создания кабинета, согласия и входа; файл cookie сессии; IP-адрес, сведения о браузере и устройстве и о действиях на странице при запросе кода входа (проверка «Я не робот»)."
              subjects="клиенты, посетители Сайта."
              basis="согласие субъекта персональных данных."
            />
            <Purpose
              title="2.3. Продвижение товаров, работ, услуг на рынке: уведомления о скидках на избранные игры и о предложениях Сайта."
              data="адрес электронной почты; идентификатор пользователя в Telegram; список избранных игр."
              subjects="клиенты, посетители Сайта."
              basis="отдельное согласие субъекта персональных данных. Его можно не давать или отозвать в любой момент, на покупки это не влияет."
            />
            <Purpose
              title="2.4. Сбор статистики и анализ использования Сайта (веб-аналитика)."
              data="сведения, собираемые метрическими программами (Яндекс Метрика, в том числе запись действий на страницах Сайта — Вебвизор: переходы, прокрутка, нажатия); IP-адрес; файлы cookie; сведения о браузере и устройстве; сведения о просмотренных страницах и отмеченных играх."
              subjects="посетители Сайта, клиенты."
              basis="согласие субъекта персональных данных. Рейтинги популярности игр формируются только из обезличенных данных."
            />
            <p>
              2.5. Оператор не обрабатывает специальные категории персональных
              данных и биометрические персональные данные и не принимает
              решений, порождающих юридические последствия для пользователя,
              исключительно на основании автоматизированной обработки.
            </p>
          </Section>

          <Section id="processing" title="3. Порядок и условия обработки">
            <p>
              3.1. Обработка осуществляется с использованием средств
              автоматизации и включает: сбор, запись, систематизацию,
              накопление, хранение, уточнение (обновление, изменение),
              извлечение, использование, передачу (предоставление, доступ),
              обезличивание, блокирование, удаление и уничтожение персональных
              данных.
            </p>
            <p>
              3.2. Персональные данные хранятся на серверах, расположенных на
              территории Российской Федерации. Трансграничная передача
              персональных данных не осуществляется.
            </p>
            <p>
              3.3. Оператор не раскрывает и не распространяет персональные
              данные без согласия субъекта, кроме случаев, предусмотренных
              законом. Для работы Сайта Оператор пользуется услугами:
            </p>
            <List
              items={[
                "хостинг-провайдера, серверы которого расположены в Российской Федерации;",
                "сервиса отправки электронной почты — для писем с заказами и кодами;",
                "сервиса пополнения кошелька Steam — он получает только логин аккаунта Steam и сумму пополнения, чтобы зачислить средства;",
                "платёжных сервисов — они получают номер и сумму заказа; персональные данные покупателя Оператор им не передаёт;",
                "сервиса веб-аналитики Яндекс Метрика, включая Вебвизор (ООО «Яндекс»);",
                "сервиса защиты от автоматических запросов Yandex SmartCaptcha (ООО «Яндекс.Облако») — когда Сайт запрашивает проверку «Я не робот» при оформлении заказа или входе в личный кабинет, сервис получает IP-адрес, сведения о браузере и устройстве и о действиях на странице.",
              ]}
            />
            <p>
              Условия обработки данных сервисом Yandex SmartCaptcha:{" "}
              <a
                className="policy-link"
                href={CAPTCHA_NOTICE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                yandex.ru/legal/smartcaptcha_notice
              </a>
              .
            </p>
            <p>
              Эти лица получают доступ к данным только в объёме, необходимом
              для оказания своих услуг.
            </p>
            <p>
              3.4. Если пользователь общается с Оператором через Telegram,
              сообщения передаются через сервис Telegram. Обработка данных
              самим сервисом Telegram регулируется его правилами.
            </p>
            <p>3.5. Сроки обработки:</p>
            <List
              items={[
                "данные заказов хранятся в течение 3 лет после исполнения заказа (срок исковой давности), затем уничтожаются или обезличиваются;",
                "данные неоплаченных заказов обезличиваются не позднее чем через 90 дней после их создания;",
                "данные личного кабинета хранятся до удаления кабинета пользователем или отзыва согласия, но не дольше 3 лет с последнего входа; коды входа удаляются через сутки после использования или окончания срока действия;",
                "данные для уведомлений о скидках хранятся до отзыва согласия;",
                "данные аналитики и технические журналы хранятся не более 12 месяцев.",
              ]}
            />
            <p>
              3.6. Обработка прекращается при достижении целей обработки,
              отзыве согласия (если нет иного законного основания) или
              выявлении неправомерной обработки.
            </p>
          </Section>

          <Section id="cookies" title="4. Файлы cookie">
            <p>
              4.1. Сайт использует технические cookie, без которых невозможны
              оформление заказа и вход в личный кабинет, а также cookie
              сервиса Яндекс Метрика для статистики посещений. Подробнее — на
              странице{" "}
              <Link className="policy-link" to="/cookies-info">
                об использовании cookie
              </Link>
              .
            </p>
            <p>
              4.2. Пользователь может отключить cookie в настройках браузера.
              В этом случае часть функций Сайта может стать недоступной.
            </p>
            <p>
              4.3. Игры, отмеченные сердечком без входа в личный кабинет,
              хранятся только в браузере пользователя (localStorage) и на Сайт
              не передаются. При входе в кабинет они переносятся в кабинет.
            </p>
          </Section>

          <Section id="rights" title="5. Права пользователя">
            <p>5.1. Пользователь вправе:</p>
            <List
              items={[
                "получать сведения об обработке своих персональных данных;",
                "требовать уточнения, блокирования или уничтожения своих данных, если они неполные, устаревшие, неточные, незаконно полученные или не нужны для заявленной цели;",
                "отозвать согласие на обработку персональных данных и отдельно — согласие на получение уведомлений о скидках;",
                "удалить личный кабинет кнопкой «Удалить кабинет» на странице кабинета;",
                "обжаловать действия Оператора в Роскомнадзоре или в суде.",
              ]}
            />
            <p>
              5.2. Запросы и отзыв согласия направляются на почту <MailLink />{" "}
              с темой «Персональные данные». Оператор отвечает на запрос в
              течение 10 рабочих дней; срок может быть продлён на 5 рабочих
              дней с уведомлением пользователя. После отзыва согласия Оператор
              прекращает обработку и уничтожает данные в срок не более 30
              дней, если иное не предусмотрено законом. Отказаться от
              уведомлений о скидках можно также по ссылке в каждом письме.
            </p>
          </Section>

          <Section id="security" title="6. Защита персональных данных">
            <p>
              6.1. Оператор принимает правовые, организационные и технические
              меры защиты данных от неправомерного доступа, уничтожения,
              изменения, блокирования, копирования и распространения:
            </p>
            <List
              items={[
                "разграничение доступа;",
                "двухфакторная аутентификация администраторов;",
                "шифрование каналов связи (HTTPS);",
                "резервное копирование;",
                "межсетевое экранирование;",
                "журналирование доступа.",
              ]}
            />
            <p>
              6.2. Обязанности лица, ответственного за организацию обработки
              персональных данных, исполняет Оператор лично.
            </p>
            <p>
              6.3. При утечке персональных данных Оператор уведомляет
              Роскомнадзор в сроки, установленные законом, и принимает меры к
              устранению последствий.
            </p>
          </Section>

          <Section id="final" title="7. Заключительные положения">
            <p>
              7.1. Политика публикуется в свободном доступе на Сайте. Оператор
              вправе вносить в неё изменения. Новая редакция вступает в силу с
              момента публикации, если иное не указано в ней. Если изменения
              затрагивают условия, на которые давалось согласие, Оператор
              запрашивает новое согласие.
            </p>
            <p>
              7.2. К отношениям, связанным с обработкой персональных данных,
              применяется законодательство Российской Федерации.
            </p>
          </Section>
        </div>
      </section>
    </Container>
  );
}

export default PrivacyPage;
